import React from 'react';
import { SITE } from '../data/siteConfig';

export const WhatsAppButton = () => {
  if (!SITE.whatsapp) return null;
  const href = `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(SITE.whatsappMessage || '')}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      aria-label="Nous contacter sur WhatsApp"
      className="fixed bottom-6 right-5 z-50 flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe5d] text-white rounded-full shadow-xl pl-3.5 pr-4 py-3 transition-transform hover:scale-105"
    >
      <svg viewBox="0 0 32 32" className="h-7 w-7 fill-white shrink-0" aria-hidden="true">
        <path d="M16.001 3C9.373 3 4 8.373 4 15c0 2.637.86 5.08 2.316 7.07L4 29l7.1-2.283A11.94 11.94 0 0 0 16 27c6.627 0 12-5.373 12-12S22.628 3 16.001 3zm0 21.8c-1.78 0-3.43-.52-4.82-1.42l-.345-.22-4.213 1.354 1.37-4.106-.226-.355A9.76 9.76 0 0 1 6.2 15c0-5.404 4.397-9.8 9.8-9.8 5.404 0 9.8 4.396 9.8 9.8s-4.396 9.8-9.799 9.8zm5.38-7.34c-.295-.148-1.747-.862-2.018-.96-.27-.1-.467-.148-.664.148-.197.295-.762.96-.934 1.157-.172.197-.344.222-.64.074-.295-.148-1.246-.459-2.374-1.465-.877-.782-1.47-1.748-1.642-2.043-.172-.296-.018-.456.13-.603.134-.133.296-.344.443-.517.148-.172.197-.296.296-.493.099-.197.05-.37-.025-.517-.074-.148-.664-1.6-.91-2.19-.24-.576-.483-.498-.664-.507l-.566-.01c-.197 0-.517.074-.788.37-.27.296-1.033 1.01-1.033 2.462 0 1.453 1.058 2.857 1.206 3.054.148.197 2.083 3.18 5.046 4.458.705.304 1.255.486 1.684.622.708.225 1.352.193 1.86.117.568-.085 1.747-.714 1.993-1.403.246-.69.246-1.28.172-1.403-.074-.123-.27-.197-.566-.345z" />
      </svg>
      <span className="font-semibold text-sm hidden sm:inline">WhatsApp</span>
    </a>
  );
};

export default WhatsAppButton;
